import React, { useMemo } from 'react';
import PageLayout from '../../components/PageLayout';
import EkvairingOrgBlock from '../../components/EkvairingOrgBlock';

export default function FederationadministratorComissionEkvairingOrg(props) {
    // const x = useMemo(()=>({ organizatorFederatsiyaID: 1 }),[])
    return (
        <PageLayout>
            <div style={{ padding: "10px" }}>
                <EkvairingOrgBlock {...props} source={"/api/ekvairingorganizatora/list"}
                    // sourceKey="fed"
                    create={true}
                    // ctx={x}
                />
            </div>
        </PageLayout>
    );
}
